var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.792 24.667c0-.848.693-1.542 1.541-1.542s1.542.694 1.542 1.542c0 .848-.694 1.541-1.542 1.541a1.546 1.546 0 0 1-1.541-1.541Zm7.708-1.542h6.167c.848 0 1.541.694 1.541 1.542 0 .848-.693 1.541-1.541 1.541H18.5a1.546 1.546 0 0 1-1.542-1.541c0-.848.694-1.542 1.542-1.542Zm9.25 7.708H9.25c-.85 0-1.542-.692-1.542-1.541v-9.25h21.584v9.25c0 .849-.693 1.541-1.542 1.541ZM9.25 9.25h1.542v1.542c0 .848.693 1.541 1.541 1.541s1.542-.694 1.542-1.541V9.25h9.25v1.542c0 .848.694 1.541 1.542 1.541.848 0 1.541-.694 1.541-1.541V9.25h1.542c.85 0 1.542.692 1.542 1.542v6.166H7.708v-6.166c0-.85.693-1.542 1.542-1.542Zm18.5-3.083h-1.542V4.625c0-.848-.693-1.542-1.541-1.542s-1.542.694-1.542 1.542v1.542h-9.25V4.625c0-.848-.694-1.542-1.542-1.542-.848 0-1.541.694-1.541 1.542v1.542H9.25a4.63 4.63 0 0 0-4.625 4.625v18.5a4.63 4.63 0 0 0 4.625 4.625h18.5a4.63 4.63 0 0 0 4.625-4.625v-18.5a4.63 4.63 0 0 0-4.625-4.625Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9f20d57be9ed7377c57e0ef16d4cafcc.svg";
export { ForwardRef as ReactComponent };